export default __webpack_public_path__ + "media/3@2x.483dcad2.jpg";